import { render, staticRenderFns } from "./FilterWrap.vue?vue&type=template&id=8f36b82c&scoped=true"
import script from "./FilterWrap.vue?vue&type=script&lang=js"
export * from "./FilterWrap.vue?vue&type=script&lang=js"
import style0 from "./FilterWrap.vue?vue&type=style&index=0&id=8f36b82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f36b82c",
  null
  
)

export default component.exports